import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {Lang} from 'yougile-lang'
import {PermissionsChecker} from '@client/permissions-checker'
import {Input} from '@components/common/base/input'
import {InputApi} from '@components/common/base/input/types'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'

export const StickerMenuTextTask = observer(() => {
  const [state, store] = useStickerStore()
  const pinningAction = useRef<boolean>(false)
  const inputElement = useRef<HTMLInputElement>()

  const canEdit =
    !store.stickerTask ||
    PermissionsChecker.checkEditTaskStickers(
      store.stickerTask,
      store.sticker,
      undefined
    )

  const handleInputChange = (api: InputApi) => {
    store.setStickerValue(api.text)
  }

  const submit = () => {
    pinningAction.current = true
    store.pinStickerValue()
    store.closeStickerMenu()
  }

  return (
    <div className="max-w-[250px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={store.sticker.title}
          showUnpin={canEdit}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className="sticker-item-cnt pt-12 pb-8 px-8 text-13">
          {Lang.msg.specifyStickerValueForThatSticker}:
          <Input
            ref={inputElement}
            className="w-full border-lists-divider-old mt-8"
            value={state.value as string}
            onChange={handleInputChange}
            onCancel={store.tryCancelAndCloseMenu}
            onSubmit={submit}
            placeholder={Lang.msg.specifyValue}
            autoFocus
            disabled={!canEdit}
          />
        </div>
      </div>
    </div>
  )
})
